import { render, staticRenderFns } from "./variable-funding.vue?vue&type=template&id=5c3ecbab&scoped=true"
import script from "./variable-funding.vue?vue&type=script&lang=js"
export * from "./variable-funding.vue?vue&type=script&lang=js"
import style0 from "./variable-funding.vue?vue&type=style&index=0&id=5c3ecbab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3ecbab",
  null
  
)

export default component.exports